<div class="swiper mySwiper" #carouselSwiper>
    <div class="store-wrapper-top" *ngIf="isShowStore">
        <img
            src="assets/svg/icons/store-appstore.svg"
            alt=""
            class="store icon"
            *ngIf="globalService.getDevicePlatform()"
            (click)="globalService.openStore('ios')"
        />
        <img
            src="assets/svg/icons/store-playstore.svg"
            alt=""
            class="store icon"
            *ngIf="globalService.getDevicePlatform('android', 'web')"
            (click)="globalService.openStore('android')"
        />
    </div>
    <div class="swiper-wrapper">
        <div class="swiper-slide">
            <div class="content-overlay">
                <div class="content-wrapper first">
                    <h4 class="title">
                        Instant <span class="text-gradient"> personal loans,</span> made <br />for the salaried
                    </h4>
                    <div class="feature-pill">
                        <div class="icon-box">✓</div>
                        <h4 class="feature-text">Fast</h4>
                        <span class="separator"></span>
                        <h4 class="feature-text">Flexible</h4>
                        <span class="separator"></span>
                        <h4 class="feature-text">Fair</h4>
                    </div>
                    <p class="text-description">Designed for reality, not rules</p>
                </div>
            </div>
            <img src="assets/images/carousel-01.webp" alt="Slide 1" />
        </div>
        <div class="swiper-slide">
            <div class="content-overlay">
                <div class="content-wrapper">
                    <h4 class="title">Close your loan anytime with <br />zero foreclosure charges</h4>
                    <div class="feature-pill">
                        <div class="icon-box">✓</div>
                        <h4 class="feature-text">Fast</h4>
                        <span class="separator"></span>
                        <h4 class="feature-text">Flexible</h4>
                        <span class="separator"></span>
                        <h4 class="feature-text">Fair</h4>
                    </div>
                    <p class="text-description">Sign up in seconds, enjoy long-term benefits</p>
                </div>
            </div>
            <img src="assets/images/carousel-02.webp" alt="Slide 2" />
        </div>
        <div class="swiper-slide">
            <div class="content-overlay">
                <div class="content-wrapper">
                    <h4 class="title">Get rewarded with<br />Klinq Points as you go</h4>
                    <div class="feature-pill">
                        <div class="icon-box">✓</div>
                        <h4 class="feature-text">Fast</h4>
                        <span class="separator"></span>
                        <h4 class="feature-text">Flexible</h4>
                        <span class="separator"></span>
                        <h4 class="feature-text">Fair</h4>
                    </div>
                    <p class="text-description">Klinq your way to a future that feels in control</p>
                </div>
            </div>
            <img src="assets/images/carousel-03.webp" alt="Slide 3" />
        </div>
        <div class="swiper-slide">
            <div class="content-overlay">
                <div class="content-wrapper">
                    <h4 class="title">Pay only for the days you use, <br />on your terms</h4>
                    <div class="feature-pill">
                        <div class="icon-box">✓</div>
                        <h4 class="feature-text">Fast</h4>
                        <span class="separator"></span>
                        <h4 class="feature-text">Flexible</h4>
                        <span class="separator"></span>
                        <h4 class="feature-text">Fair</h4>
                    </div>
                    <p class="text-description">Klinq your way to a future that feels in control</p>
                </div>
            </div>
            <img src="assets/images/carousel-04.webp" alt="Slide 4" />
        </div>
    </div>
    <!-- <div class="swiper-pagination"></div> -->
</div>
